import { render, staticRenderFns } from "./IntegralDetails.vue?vue&type=template&id=d38c9232&scoped=true&"
import script from "./IntegralDetails.vue?vue&type=script&lang=js&"
export * from "./IntegralDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntegralDetails.vue?vue&type=style&index=0&id=d38c9232&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38c9232",
  null
  
)

export default component.exports